export default{

    getStatusSchedule : state => {

        return state.statusSchedule
    }
}